module.exports = __webpack_public_path__ + "img/AUE.2a9b560d.svg";